var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsHerzrasen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-herzrasen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart-racing-dashboard-speed",
    stroke: "#7F8BDB",
    transform: "translate(0.500150, -0.004000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.4617977,
    cy: 11.0551769,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,20.1132848 L1.69875661,9.89802587 C-0.0660773128,8.13326233 -0.503828849,5.43726875 0.61196576,3.20477429 L0.61196576,3.20477429 C1.44578976,1.53789409 3.02996526,0.373367871 4.86971342,0.0749071796 C6.70946157,-0.223553512 8.58054079,0.380429839 9.89856481,1.69821767 L11.5,3.29965286 L13.1014352,1.69821767 C14.4194592,0.380429839 16.2905384,-0.223553512 18.1302866,0.0749071796 C19.9700347,0.373367871 21.5542102,1.53789409 22.3880342,3.20477429 L22.3880342,3.20477429 C23.5038288,5.43726875 23.0660773,8.13326233 21.3012434,9.89802587 L11.5,20.1132848 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.1299688,
    y1: 10.3876355,
    x2: 15.2466311,
    y2: 7.27034348,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.44384965,
    y1: 10.7402989,
    x2: 6.70336159,
    y2: 10.7402989,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.4438497,
    y1: 10.7402989,
    x2: 16.1849675,
    y2: 10.7396691,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9885361,
    y1: 8.76601391,
    x2: 15.8253768,
    y2: 9.24777722,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.1483367,
    y1: 5.52843847,
    x2: 13.6659436,
    y2: 6.69096799,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.7766757,
    y1: 5.189,
    x2: 11.7766757,
    y2: 6.44851194,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.17263475,
    y1: 5.52780871,
    x2: 9.65439807,
    y2: 6.69096799,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.23172685,
    y1: 6.82447625,
    x2: 8.12157204,
    y2: 7.71495119,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.93505931,
    y1: 8.76538415,
    x2: 7.09821859,
    y2: 9.24777722,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.62789584,
    y1: 13.8890787,
    x2: 14.2956996,
    y2: 13.8890787,
    id: "Rectangle"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsHerzrasen);
export default __webpack_public_path__ + "static/media/icons-herzrasen.0f3bfde71cf0e0cdbcad673051126442.svg";
export { ForwardRef as ReactComponent };